const notificationsListTranslationsAR = {
  notificationsListTitle: 'الإشعارات',
  notificationsList: 'الإشعارات',
};

export default notificationsListTranslationsAR;
